import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { oneAssetApi } from '../constants/constants'

@Injectable({
  providedIn: 'root'
})
export class PerformanceInvestmentService {

  private _performanceInvestUrl: string = oneAssetApi + "/Performance/Investment";

  constructor(private http: HttpClient) { }

  getPerformanceInvest(fundId, date) {
    let _body: object = {fundId: fundId, date: date}
    return this.http.post(this._performanceInvestUrl,_body)
  }
}
